import createVueComponent from '../createVueComponent';

const SignalLow = createVueComponent('SignalLowIcon', [
  ['path', { d: 'M2 20h.01' }],
  ['path', { d: 'M7 20v-4' }],
]);

export default SignalLow;
